import Popper from 'popper.js';
window.Popper = Popper;



// WEBPACK FOOTER //
// ./app/assets/granite/js/popper.js